// const config = {
//   apiBaseUrl: "http://localhost:5001", // Your API base URL
// };

// const config = {
//   apiBaseUrl: "https://nongdash.skoolbridge.host", // Your API base URL
// };

const config = {
  apiBaseUrl: "https://dashboard.bhaktipremaswami.com", // Your API base URL
};

// const config = {
//   apiBaseUrl: "https://bhaktipremaswami.com/dashboard", // Your API base URL
// };

export const API_KEY = {
  apiKey: "x7mzrfz9lvyglwter7lw6kynmzjehi34yyvocekauzvn4rq8",
};

export const LicenseInfo = {
  title: "License Information",
  description: `
  © Developers Street. All Rights Reserved.
  
  This software/product is licensed exclusively to a single user. 
  The license permits usage by one authorized user only and does not allow 
  redistribution, resale, sublicensing, or sharing with multiple users 
  without prior written permission from Developers Street.
  `,
};

export const BusinessInfo = {
  email: "thedevelopersstreet@gmail.com",
  phone: "+91 9412892908",
  social: {
    facebook: "https://www.facebook.com/developersstreet",
    instagram: "http://www.instagram.com/developersstreet",
    linkedin: "https://www.linkedin.com/company/developers-street/",
  },
};

// const config = {
//   apiBaseUrl: "https://dashboard.mayankrajjain.in", // Your API base URL
// };

// const config = {
//   apiBaseUrl: "https://test.kanpurfolk.in", // Your API base URL
// };

// const config = {
//   apiBaseUrl: "https://www.kanpurfolk.in", // Your API base URL
// };

export const AppName = {
  appName: "Bhakti Prema Swami",
};

export default config;
